import { themeService } from "theme/service/activeTheme.service";
import { ButtonStyle, CommonModalStyle } from "style/basic/commonControls";
import { languageService } from "../../../Language/language.service";
export const customForm_CMAAsset_EquipmentForm = {
  title: "Add/Edit Equipment",
  id: "customForm_CMAAsset_EquipmentForm",
  stateTitle: {
    create: languageService("Add Equipment"),
    edit: languageService("Edit Equipment"),
  },
  sections: [
    {
      id: "equipmentInfoSection",
      fields: [
        {
          id: "name", // required
          type: "input", // required
          labelValue: languageService("Name"),
          required: true,
          disabledStates: ["edit"],
          col: 4,
        },
        {
          id: "equipmentType", // required
          type: "select", // required
          labelValue: languageService("Equipment Type"),
          selectOptions: [],
          updatedSectionFieldsOnCertainValue: [
            { targetSecId: "equipmentInfoAttributesSection", getSectionFieldsCallback: "GetEquipmentTypeFormFields" },
          ],
          required: true,
          disabledStates: ["edit"],
          col: 4,
        },
      ],
    },
    {
      id: "equipmentInfoAttributesSection",
      accessor: "attributes",
      returnLabelAsKey: true,
      fields: [],
    },
    {
      id: "equipmentInfoFormButtonsSection",
      fields: [
        {
          id: "addEquipment", // required
          type: "button", // required
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addEquipment",
          position: "footer",
          hiddenStates: ["edit"],
          col: 6,
        },
        {
          id: "updateEquipment", // required
          type: "button", // required
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateEquipment",
          position: "footer",
          hiddenStates: ["create"],
          col: 6,
        },
        {
          id: "cancelEquipmentDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/AssetEquipmentTreeView/schemas/customForm_CMAAsset_EquipmentForm.js